type RadioVariant = 'disabled' | 'active' | undefined;

export function getRadioVariant(disabled?: boolean, checked?: boolean): RadioVariant {
  if (disabled) return 'disabled';
  if (checked) return 'active';
  return undefined;
}
